import { Provider as JotaiProvider } from 'jotai'
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App"
import './styles.css'
import { store as jotaiStore } from './utils/jotai-ext'

const elem = document.getElementById("root")!;
const app = (
	<StrictMode>
		<JotaiProvider store={jotaiStore}>
			<App />
		</JotaiProvider>
	</StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
